import { DATE_TIME_FORMAT, TIME_FORMAT, DATE_FORMAT } from "consts/dateTime";
import { translator } from "@flow-frontend-npm/common";

const { detectLanguage } = translator;

export const getTimeFormat = () =>
    TIME_FORMAT[detectLanguage()] || TIME_FORMAT["en"];

export const getDateFormat = () =>
    DATE_FORMAT[detectLanguage()] || DATE_FORMAT["en"];

export const getDateTimeFormat = () =>
    DATE_TIME_FORMAT[detectLanguage()] || DATE_TIME_FORMAT["en"];
